import { PublicEvent, PublicEvents } from 'utils/publicEvents/events';

export type UserLoggedInEventData = {
  userId: number;
  userName: string;
  email: string;
};

const create = (userId: number, userName: string, email: string): PublicEvent<UserLoggedInEventData> => ({
  name: PublicEvents.USER_LOGGED_IN,
  data: {
    userId,
    userName,
    email,
  },
});

const exportObject = {
  create,
};

export default exportObject;
